import { getCurrentCategoryName } from 'facetsHelper';

function updateMetaTitle(categoryName, intl, defaultTitle, sitename) {
  const categoryTitle = intl.messages[`Workforce.CategoryTitle.${categoryName}`];
  return categoryTitle
    ? intl.formatMessage({ id: `Workforce.CategoryTitle.${categoryName}` }, { sitename })
    : defaultTitle;
}

function updateMetaDescription(categoryName, intl, defaultDescription) {
  const categoryDescription = intl.messages[`Workforce.MetaDescription.${categoryName}`];
  return categoryDescription || defaultDescription;
}

function updateTitleTop(categoryName, intl, defaultTitle) {
  const categoryTitleTop = intl.messages['WorkforceHeader.CategoryTitleTop'];
  return categoryTitleTop
    ? intl.formatMessage({ id: 'WorkforceHeader.CategoryTitleTop' }, { category: categoryName })
    : defaultTitle;
}

function updateTitleBottom(intl, defaultTitle) {
  return intl.messages['WorkforceHeader.CategoryTitleTopBottom'] || defaultTitle;
}

function updateWorkforceSpecificMeta(intl, searchParams) {
  const { REACT_APP_SITENAME } = process.env;

  // Default values
  let metaTitle = intl.formatMessage({ id: 'Workforce.Title' }, { sitename: REACT_APP_SITENAME });
  let metaDescription = intl.messages['Workforce.MetaDescription'] || null;
  let titleTop = intl.formatMessage({ id: 'WorkforceHeader.TitleTop' });
  let titleBottom = intl.messages['WorkforceHeader.TitleBottom'] || null;

  const categoryName = searchParams.facets ? getCurrentCategoryName(searchParams.facets) : '';

  if (categoryName.length) {
    metaTitle = updateMetaTitle(categoryName, intl, metaTitle, REACT_APP_SITENAME);
    metaDescription = updateMetaDescription(categoryName, intl, metaDescription);
    titleTop = updateTitleTop(categoryName, intl, titleTop);
    titleBottom = updateTitleBottom(intl, titleBottom);
  }

  return {
    metaTitle,
    metaDescription,
    titleTop,
    titleBottom,
  };
}

export default updateWorkforceSpecificMeta;
